/**
 * Tailwind třídy pro vykreslení formátovaného textu. Používá je JAK editor
 * (Tiptap EditorContent), TAK veřejný render (RichTextContent) — díky tomu
 * vypadá výsledek na webu stejně jako v editoru (skutečné WYSIWYG).
 *
 * Projekt nemá @tailwindcss/typography, proto stylujeme přes arbitrary variants
 * na potomcích místo `prose`.
 */
export const RICH_TEXT_CLASS =
  // :empty drží výšku prázdného odstavce (Enter×2 v editoru) — bez toho se
  // <p></p> na webu zhroutí a mezery mezi odstavci zmizí.
  "[&_p]:my-2 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0 [&_p:empty]:min-h-[1.5em] " +
  "[&_h2]:mt-4 [&_h2]:mb-2 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:tracking-tight " +
  "[&_h3]:mt-3 [&_h3]:mb-1.5 [&_h3]:text-xl [&_h3]:font-semibold " +
  "[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 " +
  "[&_li]:my-0.5 [&_li>p]:my-0 " +
  "[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2 " +
  "[&_strong]:font-semibold [&_em]:italic [&_u]:underline [&_s]:line-through " +
  "[&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-3 [&_blockquote]:italic [&_blockquote]:text-muted-foreground " +
  "[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-sm " +
  // YouTube embed — jediný povolený <iframe> (viz sanitizeRichHtml). h-auto
  // přebíjí atribut height z Tiptapu, jinak by aspect-video neplatil.
  "[&_[data-youtube-video]]:my-3 " +
  "[&_iframe]:aspect-video [&_iframe]:h-auto [&_iframe]:w-full [&_iframe]:max-w-2xl [&_iframe]:rounded-md [&_iframe]:border-0";
